import { useTranslation } from 'react-i18next'
import * as yup from 'yup'

import { ProjectCreationForm } from '../project-creation-interface'

export const ProjectCreationValidationSchema = () => {
  const { t } = useTranslation()

  return yup.object<ProjectCreationForm>({
    name: yup.string().required(t('projectCreation.errors.nameRequired')),
  })
}
